let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("i2egy")).then(() => parcelRequire('6iScM'));